import React from 'react';
import classNames from 'classnames';

function DropdownItem({children, className, ...otherProps}) {
	return (
		<li {...otherProps} className={classNames('br-4 hover:bg-secondary-500 hover:c-white fs-4 ls-reset c-pointer', className)} style={{ padding: '6px 8px' }}>
			{children}
		</li>
	);
}
export default DropdownItem;
